import React, { Suspense, useMemo } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

import Layout from './components/Layout';
import Menu from './components/Menu';
import Footer from './components/Footer';
import PageNotFound from './components/PageNotFound';
import Home from './components/Home';
import About from './components/About';
import ErrorBoundary from './components/util/ErrorBoundary';
import ProtectedCaseStudy from './components/util/ProtectedCaseStudy';
import PasswordPage from './components/util/PasswordPage';
import { CASE_STUDY_ROUTES } from './config/menuConfig';
import useTheme from './hooks/useTheme';

import "./styles/Styles.css";

const XBert = React.lazy(() => import('./components/work/Xbert'));
const NextIQ = React.lazy(() => import('./components/work/next-iq'));
const Journal = React.lazy(() => import('./components/work/journal'));
const DesignSystem = React.lazy(() => import('./components/work/design-system'));
const HowIWork = React.lazy(() => import('./components/HowIWork'));

function App() {
  const location = useLocation();
  useTheme();
  const isCaseStudy = useMemo(
    () => CASE_STUDY_ROUTES.includes(location.pathname),
    [location.pathname]
  );

  if (location.pathname === '/password') {
    return <PasswordPage />;
  }

  return (
    <Layout>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <main id="main-content">
        {!isCaseStudy && <Menu />}

        <ErrorBoundary>
          <Suspense fallback={<div className="loading-fallback" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/xbertiq" element={<ProtectedCaseStudy><XBert /></ProtectedCaseStudy>} />
              <Route path="/next-iq" element={<ProtectedCaseStudy><NextIQ /></ProtectedCaseStudy>} />
              <Route path="/journal" element={<ProtectedCaseStudy><Journal /></ProtectedCaseStudy>} />
              <Route path="/design-system" element={<ProtectedCaseStudy><DesignSystem /></ProtectedCaseStudy>} />
              <Route path="/how-i-work" element={<ProtectedCaseStudy><HowIWork /></ProtectedCaseStudy>} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>

        <Footer />
      </main>
    </Layout>
  );
}

export default App;
